import { Button, Col, Row } from "reactstrap";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../../components/Component";
import { useEffect, useMemo, useState } from "react";
import { Table, TableColumnsType, Select as AntSelect } from "antd";
import { useFormContext } from "react-hook-form";
import QuestionerModal from "./QuestionerModal";
import misc from "../../../api/misc/dropDowns";

const QuestionerSectionForm = ({ sectionIndex }: any) => {
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [sm, setSm] = useState(false);
  const { setValue, watch, getValues } = useFormContext();
  const questionsFieldPath = `questionerSections.${sectionIndex}.questions`;
  const weightageFieldPath = `questionerSections.${sectionIndex}.sectionWeightage`;
  const evaluatorsFieldPath = `questionerSections.${sectionIndex}.evaluators`;
  const [activeQuestion, setActiveQuestion] = useState<any>({
    action: null,
    index: null,
    item: null,
  });
  const [siteUsers, setSiteUsers] = useState<any[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  const siteId = watch("siteId") || watch("projectId");
  const sectionName = watch(`questionerSections.${sectionIndex}.name`);
  const questions: any[] = watch(questionsFieldPath) || [];

  // Compute total section weightage across all sections
  const allSections = watch("questionerSections") || [];
  const currentWeightage = parseFloat(watch(weightageFieldPath)) || 0;
  const otherSectionsWeightage = allSections.reduce(
    (sum: number, s: any, i: number) =>
      i !== sectionIndex ? sum + (parseFloat(s?.sectionWeightage) || 0) : sum,
    0
  );
  const totalSectionWeightage = otherSectionsWeightage + currentWeightage;
  const sectionWeightageExceeds = totalSectionWeightage > 100;

  useEffect(() => {
    if (siteId) {
      setLoadingUsers(true);
      misc
        .fetchSiteUsers(siteId)
        .then((res: any) => {
          if (res?.status && res?.data) {
            setSiteUsers(res.data);
          } else {
            setSiteUsers([]);
          }
        })
        .catch(() => setSiteUsers([]))
        .finally(() => setLoadingUsers(false));
    }
  }, [siteId]);

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };
  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const handleDelete = (index: number) => {
    const currentQuestions = getValues(questionsFieldPath) || [];
    const updatedQuestions = currentQuestions.filter(
      (_: any, i: number) => i !== index
    );
    setValue(questionsFieldPath, updatedQuestions);
  };

  const columns: TableColumnsType<any> = useMemo(
    () => [
      {
        title: "Question",
        dataIndex: "questioner",
        key: "questioner",
      },
      {
        title: "Type",
        dataIndex: "questionType",
        key: "questionType",
      },
      {
        title: "Weightage",
        dataIndex: "questionWeightage",
        key: "questionWeightage",
        render: (text: any) => {
          const val = String(text || "").replace(/[^0-9.]/g, "");
          return val ? `${val} %` : "";
        },
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
      },
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 150,
        render: (_text: any, record: any, index: number) => (
          <>
            <Button
              size="sm"
              color=""
              onClick={() => {
                setActiveQuestion({
                  action: "edit",
                  index: index,
                  item: record,
                });
              }}
            >
              <Icon name="edit" />
            </Button>
            <Button
              size="sm"
              color=""
              onClick={() => handleDelete(index)}
            >
              <Icon name="trash" />
            </Button>
          </>
        ),
      },
    ],
    [questionsFieldPath]
  );

  const addNewRow = () => {
    setActiveQuestion({
      action: "add",
      index: null,
      item: null,
    });
  };

  const handleAppend = (data: any) => {
    const currentQuestions = getValues(questionsFieldPath) || [];
    setValue(questionsFieldPath, [...currentQuestions, data]);
  };

  const handleUpdate = (index: any, data: any) => {
    const updatedData = { ...data, errorFlag: false, errorMessage: [] };
    const currentQuestions = getValues(questionsFieldPath) || [];
    const updatedQuestions = currentQuestions.map((f: any, i: number) =>
      i === index ? updatedData : f
    );
    setValue(questionsFieldPath, updatedQuestions);
  };


  return (
    <div className="card-inner card-inner-lg">
      {sm && mobileView && (
        <div className="toggle-overlay" onClick={() => setSm(!sm)}></div>
      )}
      <BlockHead size="lg">
        <BlockBetween>
          <BlockHeadContent>
            <BlockTitle tag="h6">
              <span>{sectionName} Information for Evaluation</span>
            </BlockTitle>
          </BlockHeadContent>
        </BlockBetween>
      </BlockHead>
      <div className="content clearfix">
        {/* <FormProvider {...methods}> */}
        <form className="content clearfix">
          <Row className="mt-3">
            <div className="col-md-4 " style={{ width: "31%" }}>
              <div className="form-group mb-1">
                <div className="form-control-wrap">
                  <div className="form-control-select d-flex align-items-center">
                    <label
                      className="form-label"
                      style={{ minWidth: "35%" }}
                    >
                      Sectionwise Weightage
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Sectionwise Weightage"
                      value={watch(weightageFieldPath) || ""}
                      onChange={(e) => {
                        setValue(weightageFieldPath, e.target.value);
                      }}
                      step="any"
                      autoComplete="off"
                    />
                  </div>
                  {sectionWeightageExceeds && (
                    <span
                      className="text-danger"
                      style={{ fontSize: "12px", marginTop: "4px" }}
                    >
                      Total section weightage exceeds 100% (currently{" "}
                      {totalSectionWeightage}%)
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="form-group mb-1">
                <div className="form-control-wrap d-flex align-items-center justify-content-end">
                  <label
                    className="form-label"
                    style={{ minWidth: "120px", marginRight: 8 }}
                  >
                    Evaluator <span className="text-danger">*</span>
                  </label>
                  <AntSelect
                    mode="multiple"
                    placeholder="Select Evaluator(s)"
                    style={{ minWidth: 300 }}
                    loading={loadingUsers}
                    value={watch(evaluatorsFieldPath) || []}
                    onChange={(values) => {
                      setValue(evaluatorsFieldPath, values);
                      // Store evaluator details (id + name) for preview
                      const details = values.map((id: any) => {
                        const user = siteUsers.find(
                          (u: any) => (u.appUserId || u.userId || u.id) === id
                        );
                        return {
                          userId: id,
                          userName: user?.userName || user?.name || `${user?.firstName || ""} ${user?.lastName || ""}`.trim() || String(id),
                        };
                      });
                      setValue(`questionerSections.${sectionIndex}.evaluatorDetails`, details);
                    }}
                    options={siteUsers.map((user: any) => ({
                      label: user.userName || user.name || `${user.firstName || ""} ${user.lastName || ""}`.trim(),
                      value: user.appUserId || user.userId || user.id,
                    }))}
                    filterOption={(input, option: any) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </div>
              </div>
            </div>
          </Row>
          <div style={{ marginTop: "18px" }}></div>
          <Row>
            <div className="table-responsive">
              <div style={{ width: screenSize - 380 + "px", margin: "auto" }}>
                {columns && (
                  <Table
                    columns={columns}
                    dataSource={questions.map((q: any, i: number) => ({ ...q, key: i }))}
                    scroll={{ x: "max-content" }} // Adjust this as necessary
                    expandable={{
                      expandedRowRender: (record: any) => {
                        console.log(
                          "record?.choiceOptions",
                          record?.choiceOptions
                        );
                        return (
                          <div className="expandableBody">
                            <div style={{ flex: 1, textAlign: "left" }}>
                              {record?.choiceOptions &&
                                record.choiceOptions.length > 0 && (
                                  <>
                                    <p style={{ margin: 0 }}>Options</p>
                                    <ul className="list-group mb-3">
                                      {record.choiceOptions.map(
                                        (option: string, index: number) => (
                                          <li
                                            key={index} // It's good practice to use a key when mapping
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                          >
                                            <span>{option}</span>
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  </>
                                )}
                            </div>
                          </div>
                        );
                      },
                    }}
                    locale={{
                      emptyText: (
                        <span
                          style={{
                            height: "300px",
                            color: "#333",
                            fontSize: "16px",
                          }}
                        >
                          Please click on "Add New Item" to add question.
                        </span>
                      ),
                    }}
                    bordered
                    size="small"
                    pagination={false}
                  />
                )}
              </div>
              <Row
                style={{
                  margin: "20px",
                }}
              >
                <Col className="justify-between">
                  <a onClick={addNewRow} className="addNewItem">
                    <Icon name="plus-round" />
                    <span>Add New Question</span>
                  </a>
                </Col>
              </Row>
            </div>
          </Row>
        </form>
        {/* </FormProvider> */}
      </div>
      {activeQuestion?.action && (
        <QuestionerModal
          modal={!!activeQuestion.action}
          closeModal={() => {
            setActiveQuestion({
              action: null,
              index: null,
              item: null,
            });
          }}
          append={handleAppend} // Use the new handler
          update={handleUpdate} // Use the new handler
          formData={activeQuestion}
        />
      )}
    </div>
  );
};

export default QuestionerSectionForm;
